// Chakra imports
import {
  Text,
  Box,
  Grid,
  useColorModeValue,
  Button,
  Image,
  SimpleGrid,
} from "@chakra-ui/react";
import "./gallery.css";
import { useEffect, useRef, useState } from "react";

import Card from "components/card/Card";
import Banner from "./components/Banner";
import { useMyBandaQuery, useSponsorQuery } from "generated/graphql";
import { useSelector } from "react-redux";

export default function SponsorGallery() {
  const { user }: IUser | any = useSelector((state: UserState) => state.user);

  const [imageView, setImageView] = useState("");
  const [first, setFirst] = useState(false);
  const [refreshSelected, setRefreshSelected] = useState(false);

  const contentData = useSponsorQuery({
    fetchPolicy: "network-only",
    variables: {
      getSponsorProfileInput: {
        id: user.sponsorId,
      },
    },
  });

  console.log(contentData?.data?.sponsor?.media);

  const addedItemMiddle = (data: any) => {
    console.log(data);
    setRefreshSelected(!refreshSelected);
  };

  useEffect(() => {
    contentData.refetch();
    //setFirst(false)
  }, [refreshSelected]);

  useEffect(() => {
    if (!first && contentData?.data?.sponsor?.media.length > 0) {
      setImageView(contentData?.data?.sponsor?.media[0]);
      //   setFirst(true)
    }
  }, [contentData, refreshSelected]);

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Grid
        mb="20px"
        templateColumns={{
          base: "1fr",
          lg: "repeat(2, 1fr)",
          //  "2xl": "1.34fr 1.62fr 1fr",
        }}
        templateRows={{
          base: "1fr",
          lg: "repeat(2, 1fr)",
          "2xl": "1fr",
        }}
        gap={{ base: "20px", xl: "20px" }}
      >
        <Banner
          gridArea="1 / 1 / 2 / 1"
          banner={"banner"}
          refresh={addedItemMiddle}
          avatar={imageView}
        />

        <Card
          mb={{ base: "0px", "2xl": "20px" }}
          style={{
            height: "100%",
          }}
        >
          <SimpleGrid minChildWidth="150px" spacing="1px">
            {contentData?.data?.sponsor?.media?.map((image) => {
              if (!(image.trim() === "")) {
                return (
                  <div
                    style={
                      {
                        // backgroundColor: "red",
                      }
                    }
                  >
                    <Box
                      onClick={() => {
                        setImageView(image);
                      }}
                      height="210px"
                    >
                      <Image
                        src={image}
                        boxSize="210px"
                        objectFit="cover"

                        // w={{ base: "100%", "3xl": "100%" }}
                        // h={{ base: "100%", "3xl": "100%" }}
                        // borderRadius="20px"
                      />
                    </Box>
                  </div>
                );
              }
            })}
          </SimpleGrid>
        </Card>
      </Grid>
    </Box>
  );
}
